import { formatDateTimeStringTimeOnly } from '~/cynqueModules/utils/formatDateTimeStringTimeOnly'

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatDateTimeStringTimeOnly(value: string | null): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatDateTimeStringTimeOnly = (
    value: string | null
  ) => {
    return formatDateTimeStringTimeOnly(value)
    // if (value === null) {
    //   return value
    // }

    // if (!value) {
    //   return undefined
    // }

    // return parseISOString(value).toLocaleTimeString([], {
    //   hour: '2-digit',
    //   minute: '2-digit',
    // })
  }
})
